module.exports = {
  prefix: "usa"
};
